export default (formItems = []) =>
  formItems.reduce((allFormItemsWithRefs, item) => {
    if (!item.elementRef.current) return allFormItemsWithRefs

    return {
      ...allFormItemsWithRefs,
      [item.name]:
        item.elementRef.current.dataset.value || item.elementRef.current.value,
    }
  }, {})
